import React from 'react';
import Icons from '../../Icons';

import './style.scss';

/**
 * @param {string} value
 * @param {string} name Name for input group
 * @param {Array} options - Array of options objects [{label?: string, icon?: string, value}]
 * @param {function} onChange
 */
const CToggler = ({value, name = '', options, onChange}) => {
    return (
        <div className='c-toggler'>
            {
                options?.map((option, index) => (
                    <label
                        key={index}
                        htmlFor={option.value}
                        className={`c-toggler-input ${option.value === value ? 'active' : ''}`}
                    >
                        <input
                            id={option.value}
                            value={option.value}
                            name={name}
                            type="radio"
                            checked={option.value === value}
                            hidden
                            onChange={(e) => onChange(e.target.value)}
                        />
                        {
                            option.icon &&
                            <Icons name={option.icon} />
                        }
                        {
                            option.label &&
                            <span className='c-toggler-input-label'>
                                {option.label}
                            </span>
                        }
                    </label>
                ))
            }
            
        </div>
    )
};

export default CToggler;
